<template>
	<div class="watch-dashboard-widget personal-information-widget">
		<div class="watch-dashboard-widget-header">
			<router-link :to="{ name: 'WatchProfile', params: { user_uid: user_uid, watch_id: watch_id } }" class="header-link">
				<h1>{{ $t('base.watch.personal_information') }}</h1>
			</router-link>
		</div>
		<div class="watch-dashboard-widget-body">
			<spinner v-if="profile.loading"/>
			<error-box v-else-if="error" :error="error"/>
			<div v-else-if="profile.data">
				<table>
					<tr v-for="relation in profile.data.relations" :key="relation.id">
						<td class="compact"><b>{{ $t('categories.relations.'+relation.relation.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</b></td>
						<td class="name">{{ relation.name }}</td>
						<td class="phones">
							<div v-for="contact in relation.contacts" :key="contact.id" v-if="contact.type == 'phone'"><b>{{ $t('labels.general.phone') }}</b> {{ contact.contact }}</div>
						</td>
						<td class="emails">
							<div v-for="contact in relation.contacts" :key="contact.id" v-if="contact.type == 'email'"><b>{{ $t('labels.general.email') }}</b> {{ contact.contact }}</div>
						</td>
						<td class="addresses">
							<div v-for="contact in relation.contacts" :key="contact.id" v-if="contact.type == 'address'"><b>{{ $t('labels.general.address') }}</b> {{ contact.contact }}</div>
						</td>
					</tr>
				</table>
				<div v-if="profile.data.relations && !profile.data.relations.length">
					<router-link class="btn" :to="{ name: 'WatchProfileRelationAdd', params: { user_uid: user_uid, watch_id: watch_id } }">{{ $t('buttons.actions.add_relation') }}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch_id',
		'profile'
	],
	data () {
		return {
			error: null,
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/PersonalInformationWidget.vue